import React from 'react';

const LinkedInIcon = ({ fill = '#fff', className }) => {
    return (
        <svg width={14} height={14} viewBox="0 0 14 14" className={className}>
            <path
                d="M3.134 14H.23V4.647h2.904v9.351zM1.682 3.37A1.684 1.684 0 010 1.685C0 .755.753 0 1.682 0a1.684 1.684 0 011.19 2.876 1.68 1.68 0 01-1.19.494zM14 14h-2.9V9.451c0-1.084-.02-2.48-1.508-2.48-1.51 0-1.74 1.183-1.74 2.403V14H4.954V4.648h2.78v1.278h.04a3.047 3.047 0 012.746-1.51c2.937 0 3.48 1.937 3.48 4.455v5.128z"
                fill={fill}
                fillRule="nonzero"
            />
        </svg>
    );
};

export default LinkedInIcon;
